import {
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer,
  Layout
} from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';

const ProjectDescriptionLoading = () => {
  return (
    <div>
      <Layout>
        <Layout.Section>
          <div className="no-shadow-card">
            <Card sectioned>
              <TextContainer>
                <Layout>
                  <Layout.Section oneHalf>
                    <SkeletonDisplayText size="medium" />
                  </Layout.Section>
                  <Layout.Section>
                    <SkeletonDisplayText size="medium" />
                  </Layout.Section>
                </Layout>
              </TextContainer>
              <div className="mt10">
                <TextContainer>
                  <Layout>
                    <Layout.Section>
                      <SkeletonBodyText lines={4} />
                    </Layout.Section>
                  </Layout>
                </TextContainer>
              </div>
            </Card>
          </div>
        </Layout.Section>
      </Layout>
    </div>
  );
};

export default ProjectDescriptionLoading;
